import PolicyDoc from "@/components/PolicyDoc";
import { TOS_EFFECTIVE_DATE, tosIntro, tosSections } from "@/termsData";

export default function TermsOfService() {
  return (
    <PolicyDoc
      docTitle="Terms of Service"
      pageTitle="Terms of Service \u2014 GrowCalc"
      effectiveDate={TOS_EFFECTIVE_DATE}
      intro={tosIntro}
      sections={tosSections}
      contactNumber={11}
    />
  );
}
